import React from 'react';

import utils from './MoleculeCardUtils';
import './MoleculeCardWeb.css';


export default class MoleculeCardWeb extends React.Component {

  render() {
    const { molecule, layout, onAction, selectedComponent } = this.props;
    const thumb = utils.parseMoleculeFirst(
      molecule || {}, 'thumb', 'img_base64', 'render', null, 'small_url'
    );
    const desc = utils.parseMoleculeFirst(
      molecule || {}, 'txt', 'description', 'render'
    );
    return (
      <div
        style={{padding: 2}}
        onTouchTap={e => {
          if (onAction) {
            onAction({
              name: 'click',
              molecule: molecule,
              target: 'molecule-card-web',
            });
          }
        }}
      >
        <div
          className={'thumbnail ' + (layout === 'selected' ? '' : 'hover')}
          style={{position: 'relative'}}
        >
          <img src={thumb} alt="" />
          {selectedComponent}
          <div
            className={'dash-card-overlay ' + (layout === 'inactive' ? 'hover' : '')}
          >{desc}</div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MoleculeCard/MoleculeCardWeb.jsx